'use strict'; // module.exports = require('./dist/main.min.js');

import LightMobileCall from "./src/main.js";
export default LightMobileCall;